export { default as Img200 } from './processed/200/Equilibrium.jpg';
export { default as Img400 } from './processed/400/Equilibrium.jpg';
export { default as Imgthumb } from './processed/thumb/Equilibrium.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Equilibrium.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Equilibrium.jpg';
export const ImgData = { width: 448, height: 252, ratio: 0.5625, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      52,
      136,
      192
    ],
    "_population": 68,
    "_hsl": [
      0.5666666666666667,
      0.5737704918032788,
      0.4784313725490196
    ]
  },
  "LightVibrant": {
    "_rgb": [
      154,
      201,
      233
    ],
    "_population": 38,
    "_hsl": [
      0.5675105485232067,
      0.6422764227642275,
      0.7588235294117647
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      20,
      87,
      143
    ],
    "_population": 12,
    "_hsl": [
      0.575880758807588,
      0.7546012269938651,
      0.3196078431372549
    ]
  },
  "Muted": {
    "_rgb": [
      83,
      129,
      169
    ],
    "_population": 64,
    "_hsl": [
      0.5775193798449613,
      0.3412698412698412,
      0.49411764705882355
    ]
  },
  "LightMuted": {
    "_rgb": [
      140,
      168,
      194
    ],
    "_population": 31,
    "_hsl": [
      0.5802469135802469,
      0.3068181818181817,
      0.6549019607843137
    ]
  },
  "DarkMuted": {
    "_rgb": [
      84,
      57,
      44
    ],
    "_population": 6,
    "_hsl": [
      0.054166666666666675,
      0.3125,
      0.25098039215686274
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Equilibrium.js